<template>
  <div>
    <v-dialog v-model="detailsDialog" max-width="900px" @click:outside="closeDetails" @keydown.esc="closeDetails">
      <v-card class="pa-6" v-if="!loadingDetails">
        <v-container>
          <v-layout row>
            <v-flex md6>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="title">{{$t('correction_details')}}</v-list-item-title>
                  <v-list-item-subtitle class="subtitle-2">{{ details_approvall.id }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
            <v-flex md6></v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2">{{$t('requested_by')}}</v-list-item-title>
                  <v-list-item-title class="subtitle-1 font-weight-bold">{{ returnNull(approval_name.full_name) }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption mb-2">{{ returnNull(approval_name.job_position) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
            <v-flex md6></v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row>
            <v-flex md12>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="title">
                    <v-icon small color="primary">mdi-calendar-remove</v-icon>{{$t('before')}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('checkin')}}</span>
                  <span v-if="data_before !== undefined" class="caption">
                  <span v-if="data_before !== undefined">{{ milisToHour(returnNull(data_before.time_in)) }}</span> <span v-else>-</span> |
                    <v-chip label x-small v-bind:class="checkReasonColor(data_before.reason_in)">
                      {{ returnNull(data_before.reason_in) }}</v-chip>
                  </span>
                  <span v-else>-</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_reason_in')}}</span>
                  <span v-if="data_before !== undefined" class="caption">{{ returnNull(data_before.reason_user_in) }}</span>
                  <span v-else>-</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('address_in')}}</span>
                  <span v-if="data_before !== undefined" class="caption">{{ returnNull(data_before.address) }}</span>
                   <span v-else>-</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_note_in')}}</span>
                  <span v-if="data_before !== undefined" class="caption mb-2">{{ returnNull(data_before.note_user_in) }}</span>
                   <span v-else>-</span>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
            <v-flex md6>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('checkout')}}</span>
                  <span  v-if="data_before !== undefined">
                  <span v-if="data_before.time_out == 0">-</span>
                  <span v-else class="caption">
                    <span v-if="data_before !== undefined">
                    {{ milisToHour(returnNull(data_before.time_out)) }} |
                    <v-chip v-if="data_before.status == 'checkout'" x-small label>{{$t('checkout')}}</v-chip>
                    <span v-else-if="data_before.status == 'checkoutbysystem'">
                      <v-chip x-small label>{{$t('by_system')}}</v-chip>
                    </span>
                    <span v-else>
                      -
                    </span>
                    </span>
                    </span>
                  </span>
                    <span v-else>
                      -
                    </span>
                  
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_reason_out')}}</span>
                  <span class="caption" v-if="data_before !== undefined">{{ returnNull(data_before.reason_user_out) }}</span>
                  <span v-else>-</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('address_out')}}</span>
                  <span class="caption" v-if="data_before !== undefined">{{ returnNull(data_before.address_out) }}</span>
                   <span v-else>-</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_note_out')}}</span>
                  <span v-if="data_before !== undefined" class="caption">{{ returnNull(data_before.note_user_out) }}</span>
                  <span v-else>-</span>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row>
            <v-flex md12>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="title">
                    <v-icon small color="primary">mdi-calendar-check</v-icon>{{$t('after')}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('checkin')}}</span>
                  <span class="caption orange--text">
                    {{
                    milisToHour(data_after.time_in_after)
                    }}
                  </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_reason_in')}}</span>
                  <span class="caption orange--text">{{ data_after.reason_user_in_after }}</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('address_in')}}</span>
                  <span class="caption orange--text">
                    {{
                    data_after.address_in
                    }}
                  </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_note_in')}}</span>
                  <span class="caption mb-2 orange--text">{{ data_after.note_user_in_after }}</span>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
            <v-flex md6>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('checkout')}}</span>
                  <span v-if="data_after.time_out_after == 0">-</span>
                  <span v-else class="caption orange--text">
                    {{
                    milisToHour(data_after.time_out_after)
                    }}
                  </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_reason_out')}}</span>
                  <span class="caption">{{ data_after.reason_user_out_after }}</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('address_out')}}</span>
                  <span class="caption orange--text">{{ data_after.address_out }}</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_note_out')}}</span>
                  <span class="caption orange--text">{{ data_after.note_user_out_after }}</span>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="6">
              <v-list-item>
                <v-list-item-content>
                  <div>
                    <v-list-item-title class="subtitle-2 mb-2 font-weight-bold">
                      <v-icon small color="primary">mdi-comment-alert</v-icon>{{$t('status_approval')}}
                    </v-list-item-title>
                    <!-- <div v-if="details_approvall.approval_type != 1">
                    <span class="subtitle-2">{{$t('approver')}} 1</span>
                    <v-list-item-title class="caption mt-1">
                      {{approverCondition(1 , details_approvall.status)}}
                      <b v-if="name_approver">{{ returnNull(name_approver.full_name) }}</b>
                      <b v-else>-</b>
                    </v-list-item-title>
                    </div>
                    <div>
                     <span class="subtitle-2">{{$t('approver')}} {{details_approvall.approval_type == 1 ? '' : 2}}</span>
                      <v-list-item-title class="caption mt-1">
                        {{approverCondition(2, details_approvall.status)}}
                        <b>{{ returnNull(name_approver2.full_name) }}</b>
                      </v-list-item-title>
                    </div> -->
                    <template v-if="allApprover.length > 0">
                      <div v-for="(item, index) in allApprover" :key="index">
                        <span class="subtitle-2">{{$t('approver')}} {{allApprover.length > 1 ? index + 1 : ''}}</span>
                        <v-list-item-title class="caption mt-1">
                          {{approverCondition(allApprover.length > 1 ? index + 1 : 1, details_approvall.status)}}
                          <b>{{ returnNull(item.full_name) }}</b>
                        </v-list-item-title>
                      </div>
                    </template>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="6">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2 font-weight-bold">
                    <v-icon small color="primary">mdi-comment-alert</v-icon>{{$t('comments')}}
                  </v-list-item-title>
                  <div style="max-height: 300px; overflow:auto;">
                    <div v-for="(item, i) in commentApprover" :key="i">
                      <v-list-item-title class="subtitle-2">
                        <span class="font-weight-black caption">
                          {{
                        returnNull(item.user.full_name)
                        }}
                        </span>
                      </v-list-item-title>
                      <v-list-item-title class="subtitle-2">
                        <span class="caption">{{ milisToHour(item.timestamp) }}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle class="mb-2" style="white-space: normal;">
                        <span v-if="
                          item.status == 'submitted' &&
                            item.comment == 'Submitted'
                        " class="caption">{{$t('need_approval')}}</span>
                        <span v-if="
                          item.status == 'submitted' &&
                            item.comment == 'Revised'
                        " class="caption">{{$t('need_approval')}}</span>
                        <span v-else-if="
                          (item.status == 'l1Approved' || item.status == 'approved') &&
                            item.comment == 'Approved'
                        " class="caption">{{$t('you_have_agreed')}}</span>
                        <span v-else-if="
                          (item.status == 'l2Approved' || item.status == 'approved') &&
                            item.comment == 'Approved'
                        " class="caption">{{$t('you_have_agreed')}}</span>
                        <span v-else-if="
                          item.status == 'l1Revised' &&
                            item.comment == 'Revised'
                        " class="caption">{{$t('waiting_revision')}}</span>
                        <span v-else-if="
                          item.status == 'l2Revised' &&
                            item.comment == 'Revised'
                        " class="caption">{{$t('waiting_revision')}}</span>
                        <span v-else-if="
                          item.status == 'l1Rejected' &&
                            item.comment == 'Rejected'
                        " class="caption">{{$t('you_have_rejected')}}</span>
                        <span v-else-if="
                          item.status == 'l2Rejected' &&
                            item.comment == 'Rejected'
                        " class="caption">{{$t('you_have_rejected')}}</span>
                        <span v-if="item.comment == 'Rejected'" class="caption" v-show="false"></span>
                        <span v-else-if="item.comment == 'Submitted'" class="caption" v-show="false"></span>
                        <span v-else-if="item.comment == 'Revised'" class="caption" v-show="false"></span>
                        <span v-else-if="item.comment == 'Approved'" class="caption" v-show="false"></span>
                        <span v-else v-show="true" class="caption">{{ checkComment(item.comment) }}</span>
                      </v-list-item-subtitle>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <div v-if="firebaseUID == details_approvall.approverId || (firebaseUID == details_approvall.approver2Id && details_approvall.approval_type == 1)">
            <v-layout row wrap>
              <v-flex md6></v-flex>
              <v-flex md6>
                <v-list-item>
                  <v-list-item-content class="justify-end">
                    <v-dialog v-model="commentDialog" max-width="700px" persistent>
                      <template v-slot:activator="{ on }">
                        <v-btn color="red" dark v-on="on">
                          {{$t('reject')}}
                          <v-icon dark right>mdi-cancel</v-icon>
                        </v-btn>
                      </template>
                      <v-form v-model="valid">
                        <v-card class="pa-6 pt-3">
                          <v-container>
                            <v-layout row>
                              <v-flex md12>
                                <v-layout justify-center>
                                  <v-radio-group class="justify-center" row v-model="status_radio" :mandatory="true">
                                    <v-flex md6>
                                      <v-card class="mb-5 mr-3" style="cursor:pointer">
                                        <v-list-item three-line>
                                          <v-list-item-content>
                                            <v-radio color="primary" value="l1Revised" selected class="justify-center">
                                            </v-radio>
                                            <v-list-item-title class="title orange--text text-center">
                                              <v-icon small class="orange--text">mdi-file-document-edit</v-icon>
                                              &nbsp;{{$t('revise')}}
                                            </v-list-item-title>
                                            <span class="overline text-center">
                                               {{$t('if_inappropriate')}}
                                            </span>
                                          </v-list-item-content>
                                        </v-list-item>
                                      </v-card>
                                    </v-flex>
                                    <v-flex md6>
                                      <v-card class="ml-3" style="cursor:pointer">
                                        <v-list-item three-line>
                                          <v-list-item-content>
                                            <v-radio color="primary" value="l1Rejected" class="justify-center">
                                            </v-radio>
                                            <v-list-item-title class="title error--text text-center">
                                              <v-icon small class="error--text">mdi-file-cancel</v-icon>&nbsp;{{$t('reject')}}
                                            </v-list-item-title>
                                            <span class="overline text-center">
                                              {{$t('please_fill')}}
                                            </span>
                                          </v-list-item-content>
                                        </v-list-item>
                                      </v-card>
                                    </v-flex>
                                  </v-radio-group>
                                </v-layout>
                                <v-divider></v-divider>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-textarea color="primary" v-model="comment_value" :rules="rules" filled>
                                      <template v-slot:label>
                                        <div>{{$t('reason_rejection')}}</div>
                                      </template>
                                    </v-textarea>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-flex md-12>
                                  <v-list-item>
                                    <v-list-item-content class="justify-end">
                                      <v-btn color="primary" class="mr-2" text @click="cancelReject">{{$t('cancel')}}</v-btn>
                                      <v-btn color="primary" :disabled="!valid" @click="rejectItem()">{{$t('send')}}</v-btn>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-flex>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-form>
                    </v-dialog>
                    <v-btn color="primary" dark @click="approveItem()">
                     {{$t('approve')}}
                      <v-icon dark right>mdi-checkbox-marked-circle</v-icon>
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
              </v-flex>
            </v-layout>
          </div>
          <div v-else-if="
              (firebaseUID == details_approvall.approver2Id &&
              (details_approvall.status == 'l1Approved' || details_approvall.status == 'approved')) || (firebaseUID == details_approvall.approver2Id && details_approvall.approval_type == 1)
">
            <v-layout row wrap>
              <v-flex md6></v-flex>
              <v-flex md6>
                <v-list-item>
                  <v-list-item-content class="justify-end">
                    <v-dialog v-model="commentDialog" max-width="700px" persistent>
                      <template v-slot:activator="{ on }">
                        <v-btn color="red" dark v-on="on">
                          {{$t('reject')}}
                          <v-icon dark right>mdi-cancel</v-icon>
                        </v-btn>
                      </template>
                      <v-form v-model="valid">
                        <v-card class="pa-6 pt-3">
                          <v-container>
                            <v-layout row>
                              <v-flex md12>
                                <v-layout justify-center>
                                  <v-radio-group class="justify-center" row v-model="status_radio" :mandatory="true">
                                    <v-flex md6>
                                      <v-card class="mb-5 mr-3" style="cursor:pointer">
                                        <v-list-item three-line>
                                          <v-list-item-content>
                                            <v-radio color="primary" value="l2Revised" selected class="justify-center">
                                            </v-radio>
                                            <v-list-item-title class="title orange--text text-center">
                                              <v-icon small class="orange--text">mdi-file-document-edit</v-icon>
                                              &nbsp;{{$t('revise')}}
                                            </v-list-item-title>
                                            <span class="overline text-center">
                                               {{$t('if_inappropriate')}}
                                            </span>
                                          </v-list-item-content>
                                        </v-list-item>
                                      </v-card>
                                    </v-flex>
                                    <v-flex md6>
                                      <v-card class="ml-3" style="cursor:pointer">
                                        <v-list-item three-line>
                                          <v-list-item-content>
                                            <v-radio color="primary" value="l2Rejected" class="justify-center">
                                            </v-radio>
                                            <v-list-item-title class="title error--text text-center">
                                              <v-icon small class="error--text">mdi-file-cancel</v-icon>&nbsp;{{$t('reject')}}
                                            </v-list-item-title>
                                            <span class="overline text-center">
                                              {{$t('please_fill')}}
                                            </span>
                                          </v-list-item-content>
                                        </v-list-item>
                                      </v-card>
                                    </v-flex>
                                  </v-radio-group>
                                </v-layout>
                                <v-divider></v-divider>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-textarea color="primary" v-model="comment_value" :rules="rules" filled>
                                      <template v-slot:label>
                                        <div>{{$t('reason_rejection')}}</div>
                                      </template>
                                    </v-textarea>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-flex md-12>
                                  <v-list-item>
                                    <v-list-item-content class="justify-end">
                                      <v-btn color="primary" class="mr-2" text @click="cancelReject">{{$t('cancel')}}</v-btn>
                                      <v-btn color="primary" :disabled="!valid" @click="rejectItem()">{{$t('send')}}</v-btn>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-flex>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-form>
                    </v-dialog>
                    <v-btn color="primary" dark @click="approveItem()">
                     {{$t('approve')}}
                      <v-icon dark right>mdi-checkbox-marked-circle</v-icon>
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
              </v-flex>
            </v-layout>
          </div>
        </v-container>
      </v-card>
      <v-card class="pa-6" v-if="loadingDetails">
        <v-row>
          <v-skeleton-loader class="mx-auto" type="table-tbody"></v-skeleton-loader>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="viewDialog" max-width="900px" @click:outside="closeDetails" @keydown.esc="closeDetails">
      <v-card class="pa-6" v-if="!loadingDetails">
        <v-container>
          <v-layout row>
            <v-flex md6>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="title">{{$t('correction_details')}}</v-list-item-title>
                  <v-list-item-subtitle class="subtitle-2">{{ details_approvall.id }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
            <v-flex md6></v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2">{{$t('requested_by')}}</v-list-item-title>
                  <v-list-item-title class="subtitle-1 font-weight-bold">{{ returnNull(approval_name.full_name) }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption mb-2">{{ approval_name.job_position }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
            <v-flex md6>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row>
            <v-flex md12>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="title">
                    <v-icon small color="primary">mdi-calendar-remove</v-icon>{{$t('before')}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>
              <v-list-item>
                <v-list-item-content v-if="data_before !== undefined">
                  <span class="caption font-weight-bold">{{$t('checkin')}}</span>
                  <span v-if="data_before.reason_in" class="caption">
                    <span v-if="data_before !== undefined">{{ milisToHour(returnNull(data_before.time_in)) }}</span> <span v-else>-</span> |
                    <v-chip label x-small v-bind:class="checkReasonColor(data_before.reason_in)">
                      {{ returnNull(data_before.reason_in) }}</v-chip>
                  </span>
                  <span v-else class="caption">
                    <span v-if="data_before !== undefined">{{ milisToHour(returnNull(data_before.time_in)) }}</span> <span v-else>-</span> |
                    <v-chip v-if="
                        data_before.reason_in == 'null' ||
                          data_before.status == 'absent'
                      " x-small label>{{$t('absent')}}</v-chip>
                  </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_reason_in')}}</span>
                  <span v-if="data_before !== undefined" class="caption">{{ returnNull(data_before.reason_user_in) }}</span>
                  <span v-else> - </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('address_in')}}</span>
                  <span v-if="data_before !== undefined" class="caption">{{ returnNull(data_before.address) }}</span>
                   <span v-else> - </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_note_in')}}</span>
                  <span v-if="data_before !== undefined" class="caption mb-2">{{ returnNull(data_before.note_user_in) }}</span>
                   <span v-else> - </span>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
            <v-flex md6>
              <v-list-item>
                <v-list-item-content >
                  <span class="caption font-weight-bold">{{$t('checkout')}}</span>
                  <span v-if="data_before !== undefined">
                  <span v-if="data_before.time_out == 0">-</span>
                  <span v-else class="caption">
                    {{ milisToHour(data_before.time_out) }} |
                    <v-chip v-if="data_before.status == 'checkout'" x-small label>{{$t('checkout')}}</v-chip>
                    <span v-else-if="data_before.status == 'checkoutbysystem'">
                      <v-chip x-small label>{{$t('by_system')}}</v-chip>
                    </span>
                    <span v-else-if="data_before.status == 'absent'">
                      <v-chip x-small label>{{$t('absent')}}</v-chip>
                    </span>
                  </span>
                  </span>
                  <span v-else>
                    -
                  </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_reason_out')}}</span>
                  <span  v-if="data_before !== undefined" class="caption">{{ returnNull(data_before.reason_user_out) }}</span>
                     <span v-else> - </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('address_out')}}</span>
                  <span  v-if="data_before !== undefined" class="caption">{{ returnNull(data_before.address_out) }}</span>
                     <span v-else> - </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_note_out')}}</span>
                  <span  v-if="data_before !== undefined" class="caption">{{ returnNull(data_before.note_user_out) }}</span>
                     <span v-else> - </span>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row>
            <v-flex md12>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="title">
                    <v-icon small color="primary">mdi-calendar-check</v-icon>{{$t('after')}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('checkin')}}</span>
                  <span class="caption orange--text">
                    {{
                    milisToHour(data_after.time_in_after)
                    }}
                  </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_reason_in')}}</span>
                  <span class="caption orange--text">{{ data_after.reason_user_in_after }}</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('address_in')}}</span>
                  <span class="caption orange--text">
                    {{
                    data_after.address_in
                    }}
                  </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_note_in')}}</span>
                  <span class="caption mb-2 orange--text">{{ data_after.note_user_in_after }}</span>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
            <v-flex md6>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('checkout')}}</span>
                  <span class="orange--text" v-if="data_after.time_out_after == 0">-</span>
                  <span v-else class="caption orange--text">
                    {{
                    milisToHour(data_after.time_out_after)
                    }}
                  </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_reason_out')}}</span>
                  <span class="caption orange--text">{{ data_after.reason_user_out_after }}</span>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('address_out')}}</span>
                  <span class="caption orange--text">{{ data_after.address_out }}</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_note_out')}}</span>
                  <span class="caption orange--text">{{ data_after.note_user_out_after }}</span>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="6">
              <v-list-item>
                <v-list-item-content>
                  <div>
                    <v-list-item-title class="subtitle-2 mb-2 font-weight-bold">
                      <v-icon small color="primary">mdi-comment-alert</v-icon>{{$t('status_approval')}}
                    </v-list-item-title>
                         <!-- <div v-if="details_approvall.approval_type != 1">
                    <span class="subtitle-2">{{$t('approver')}} 1</span>
                    <v-list-item-title class="caption mt-1">
                      {{approverCondition(1 , details_approvall.status)}}
                      <b v-if="name_approver">{{ returnNull(name_approver.full_name) }}</b>
                      <b v-else>-</b>
                    </v-list-item-title>
                         </div>
                    <div>
                      <span class="subtitle-2">{{$t('approver')}} {{details_approvall.approval_type == 1 ? '' : 2}}</span>
                      <v-list-item-title class="caption mt-1">
                        {{approverCondition(2, details_approvall.status)}}
                        <b>{{ returnNull(name_approver2.full_name) }}</b>
                      </v-list-item-title>
                    </div> -->
                    <template v-if="allApprover.length > 0">
                      <div v-for="(item, index) in allApprover" :key="index">
                        <span class="subtitle-2">{{$t('approver')}} {{allApprover.length > 1 ? index + 1 : ''}}</span>
                        <v-list-item-title class="caption mt-1">
                          {{approverCondition(allApprover.length > 1 ? index + 1 : 1, details_approvall.status)}}
                          <b>{{ returnNull(item.full_name) }}</b>
                        </v-list-item-title>
                      </div>
                    </template>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="6">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2 font-weight-bold">
                    <v-icon small color="primary">mdi-comment-alert</v-icon>{{$t('comments')}}
                  </v-list-item-title>
                  <div style="max-height: 300px; overflow:auto;">
                    <div v-for="(item, i) in commentApprover" :key="i">
                      <v-list-item-title class="subtitle-2">
                        <span class="font-weight-black caption">
                          {{
                        returnNull(item.user.full_name)
                        }}
                        </span>
                      </v-list-item-title>
                      <v-list-item-title class="subtitle-2">
                        <span class="caption">{{ milisToHour(item.timestamp) }}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle class="mb-2" style="white-space: normal;">
                        <span v-if="
                          item.status == 'submitted' &&
                            item.comment == 'Submitted'
                        " class="caption">{{$t('need_approval')}}</span>
                        <span v-if="
                          item.status == 'submitted' &&
                            item.comment == 'Revised'
                        " class="caption">{{$t('need_approval')}}</span>
                        <span v-else-if="
                          (item.status == 'l1Approved' || item.status == 'approved') &&
                            item.comment == 'Approved'
                        " class="caption">{{$t('you_have_agreed')}}</span>
                        <span v-else-if="
                          (item.status == 'l2Approved' || item.status == 'approved') &&
                            item.comment == 'Approved'
                        " class="caption">{{$t('you_have_agreed')}}</span>
                        <span v-else-if="
                          item.status == 'l1Revised' &&
                            item.comment == 'Revised'
                        " class="caption">{{$t('waiting_revision')}}</span>
                        <span v-else-if="
                          item.status == 'l2Revised' &&
                            item.comment == 'Revised'
                        " class="caption">{{$t('waiting_revision')}}</span>
                        <span v-else-if="
                          item.status == 'l1Rejected' &&
                            item.comment == 'Rejected'
                        " class="caption">{{$t('you_have_rejected')}}</span>
                        <span v-else-if="
                          item.status == 'l2Rejected' &&
                            item.comment == 'Rejected'
                        " class="caption">{{$t('you_have_rejected')}}</span>
                        <span v-if="item.comment == 'Rejected'" class="caption" v-show="false"></span>
                        <span v-else-if="item.comment == 'Submitted'" class="caption" v-show="false"></span>
                        <span v-else-if="item.comment == 'Revised'" class="caption" v-show="false"></span>
                        <span v-else-if="item.comment == 'Approved'" class="caption" v-show="false"></span>
                        <span v-else v-show="true" class="caption">{{ checkComment(item.comment) }}</span>
                      </v-list-item-subtitle>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <v-card class="pa-6" v-if="loadingDetails">
        <v-row>
          <v-skeleton-loader class="mx-auto" type="table-tbody"></v-skeleton-loader>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="approveDialog" max-width="900px" @click:outside="closeDetails" @keydown.esc="closeDetails">
      <v-card class="pa-6" v-if="!loadingDetails">
        <v-container>
          <v-layout row>
            <v-flex md6>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="title">{{$t('correction_details')}}</v-list-item-title>
                  <v-list-item-subtitle class="subtitle-2">{{ details_approvall.id }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
            <v-flex md6></v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2">{{$t('requested_by')}}</v-list-item-title>
                  <v-list-item-title class="subtitle-1 font-weight-bold">{{ returnNull(approval_name.full_name) }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption mb-2">{{ returnNull(approval_name.job_position) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
            <v-flex md6>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row>
            <v-flex md12>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="title">
                    <v-icon small color="primary">mdi-calendar-check</v-icon>{{$t('approved')}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md12>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="title">
                    <v-icon small color="primary">mdi-calendar-remove</v-icon>{{$t('before')}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>
              <v-list-item>
                <v-list-item-content  v-if="data_before !== undefined">
                  <span class="caption font-weight-bold">{{$t('checkin')}}</span>
                  <span v-if="data_before.reason_in || data_before.reason_in !== undefined" class="caption">
                    <span v-if="data_before !== undefined">{{ milisToHour(returnNull(data_before.time_in)) }}</span> <span v-else>-</span> |
                    <v-chip label x-small v-bind:class="checkReasonColor(data_before.reason_in)">
                      {{ returnNull(data_before.reason_in) }}</v-chip>
                  </span>
                  <span v-else class="caption">
                     <span v-if="data_before !== undefined">{{ milisToHour(returnNull(data_before.time_in)) }}</span> <span v-else>-</span> |
                    <v-chip v-if="
                        data_before.reason_in == 'null' ||
                          data_before.status == 'absent'
                      " x-small label>{{$t('absent')}}</v-chip>
                  </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_reason_in')}}</span>
                  <span  v-if="data_before !== undefined" class="caption">{{ returnNull(data_before.reason_user_in) }}</span>
                  <span v-else>-</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('address_in')}}</span>
                  <span  v-if="data_before !== undefined" class="caption">{{ returnNull(data_before.address) }}</span>
                  <span v-else>-</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_note_in')}}</span>
                  <span  v-if="data_before !== undefined" class="caption mb-2">{{ returnNull(data_before.note_user_in) }}</span>
                  <span v-else>-</span>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
            <v-flex md6>
              <v-list-item>
                <v-list-item-content >
                  <span class="caption font-weight-bold">{{$t('checkout')}}</span>
                  <span v-if="data_before !== undefined" >
                  <span v-if="data_before.time_out == 0">-</span>
                  <span v-else class="caption">
                    {{ milisToHour(data_before.time_out) }} |
                    <v-chip v-if="data_before.status == 'checkout'" x-small label>{{$t('checkout')}}</v-chip>
                    <span v-else-if="data_before.status == 'checkoutbysystem'">
                      <v-chip x-small label>{{$t('by_system')}}</v-chip>
                    </span>
                    <span v-else-if="data_before.status == 'absent'">
                      <v-chip x-small label>{{$t('absent')}}</v-chip>
                    </span>
                  </span>
                  </span>
                   <span v-else>-</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_reason_out')}}</span>
                  <span class="caption" v-if="data_before !== undefined" >{{ returnNull(data_before.reason_user_out) }}</span>
                    <span v-else>-</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('address_out')}}</span>
                  <span class="caption" v-if="data_before !== undefined" >{{ returnNull(data_before.address_out) }}</span>
                    <span v-else>-</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_note_out')}}</span>
                  <span class="caption" v-if="data_before !== undefined" >{{ returnNull(data_before.note_user_out) }}</span>
                    <span v-else>-</span>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row>
            <v-flex md12>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="title">
                    <v-icon small color="primary">mdi-calendar-check</v-icon>{{$t('after')}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('checkin')}}</span>
                  <span class="caption orange--text">
                    {{
                    milisToHour(data_after.time_in_after)
                    }}
                  </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_reason_in')}}</span>
                  <span class="caption orange--text">{{ data_after.reason_user_in_after }}</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('address_in')}}</span>
                  <span class="caption orange--text">
                    {{
                    data_after.address_in
                    }}
                  </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_note_in')}}</span>
                  <span class="caption mb-2 orange--text">{{ data_after.note_user_in_after }}</span>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
            <v-flex md6>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('checkout')}}</span>
                  <span class="orange--text" v-if="data_after.time_out_after == 0">-</span>
                  <span v-else class="caption orange--text">
                    {{
                    milisToHour(data_after.time_out_after)
                    }}
                  </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_reason_out')}}</span>
                  <span class="caption orange--text">{{ data_after.reason_user_out_after }}</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('address_out')}}</span>
                  <span class="caption orange--text">{{ data_after.address_out }}</span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <span class="caption font-weight-bold">{{$t('user_note_out')}}</span>
                  <span class="caption orange--text">{{ data_after.note_user_out_after }}</span>
                </v-list-item-content>
              </v-list-item>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="6">
              <v-list-item>
                <v-list-item-content>
                  <div>
                    <v-list-item-title class="subtitle-2 mb-2 font-weight-bold">
                      <v-icon small color="primary">mdi-comment-alert</v-icon>{{$t('status_approval')}}
                    </v-list-item-title>
                         <!-- <div v-if="details_approvall.approval_type != 1">
                    <span class="subtitle-2">{{$t('approver')}} 1</span>
                    <v-list-item-title class="caption mt-1">
                      {{approverCondition(1 , details_approvall.status)}}
                      <b v-if="name_approver">{{ returnNull(name_approver.full_name) }}</b>
                      <b v-else>-</b>
                    </v-list-item-title>
                         </div>
                    <div>
                     <span class="subtitle-2">{{$t('approver')}} {{details_approvall.approval_type == 1 ? '' : 2}}</span>
                      <v-list-item-title class="caption mt-1">
                        {{approverCondition(2, details_approvall.status)}}
                        <b>{{ returnNull(name_approver2.full_name) }}</b>
                      </v-list-item-title>
                    </div> -->
                    <template v-if="allApprover.length > 0">
                      <div v-for="(item, index) in allApprover" :key="index">
                        <span class="subtitle-2">{{$t('approver')}} {{allApprover.length > 1 ? index + 1 : ''}}</span>
                        <v-list-item-title class="caption mt-1">
                          {{approverCondition(allApprover.length > 1 ? index + 1 : 1, details_approvall.status)}}
                          <b>{{ returnNull(item.full_name) }}</b>
                        </v-list-item-title>
                      </div>
                    </template>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="6">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2 font-weight-bold">
                    <v-icon small color="primary">mdi-comment-alert</v-icon>{{$t('comments')}}
                  </v-list-item-title>
                  <div style="max-height: 300px; overflow:auto;">
                    <div v-for="(item, i) in commentApprover" :key="i">
                      <v-list-item-title class="subtitle-2">
                        <span class="font-weight-black caption">
                          {{
                        returnNull(item.user.full_name)
                        }}
                        </span>
                      </v-list-item-title>
                      <v-list-item-title class="subtitle-2">
                        <span class="caption">{{ milisToHour(item.timestamp) }}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle class="mb-2" style="white-space: normal;">
                        <span v-if="
                          item.status == 'submitted' &&
                            item.comment == 'Submitted'
                        " class="caption">{{$t('need_approval')}}</span>
                        <span v-if="
                          item.status == 'submitted' &&
                            item.comment == 'Revised'
                        " class="caption">{{$t('need_approval')}}</span>
                        <span v-else-if="
                          (item.status == 'l1Approved' || item.status == 'approved') &&
                            item.comment == 'Approved'
                        " class="caption">{{$t('you_have_agreed')}}</span>
                        <span v-else-if="
                          (item.status == 'l2Approved' || item.status == 'approved') &&
                            item.comment == 'Approved'
                        " class="caption">{{$t('you_have_agreed')}}</span>
                        <span v-else-if="
                          item.status == 'l1Revised' &&
                            item.comment == 'Revised'
                        " class="caption">{{$t('waiting_revision')}}</span>
                        <span v-else-if="
                          item.status == 'l2Revised' &&
                            item.comment == 'Revised'
                        " class="caption">{{$t('waiting_revision')}}</span>
                        <span v-else-if="
                          item.status == 'l1Rejected' &&
                            item.comment == 'Rejected'
                        " class="caption">{{$t('you_have_rejected')}}</span>
                        <span v-else-if="
                          item.status == 'l2Rejected' &&
                            item.comment == 'Rejected'
                        " class="caption">{{$t('you_have_rejected')}}</span>
                        <span v-if="item.comment == 'Rejected'" class="caption" v-show="false"></span>
                        <span v-else-if="item.comment == 'Submitted'" class="caption" v-show="false"></span>
                        <span v-else-if="item.comment == 'Revised'" class="caption" v-show="false"></span>
                        <span v-else-if="item.comment == 'Approved'" class="caption" v-show="false"></span>
                        <span v-else v-show="true" class="caption">{{ checkComment(item.comment) }}</span>
                      </v-list-item-subtitle>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <v-card class="pa-6" v-if="loadingDetails">
        <v-row>
          <v-skeleton-loader class="mx-auto" type="table-tbody"></v-skeleton-loader>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  export default {
    name: "Correction",
    props: ["detailsDialog", 'allApprover', "viewDialog", "loadingDetails", "details_approvall", "rules", "name_approver",
      "name_approver2",
      "approval_name", "data_before",
      "data_after", "milisToHour", "commentApprover", "checkReasonColor", "checkReasonApproveColor", "approveDialog",
      "checkNoteApproveColor", "firebaseUID", 'checkApprover', "approveItem", "approverCondition", "approvalType"
    ],
    data() {
      return {
        valid: true,
        commentDialog: false,
        comment_value: null,
        status_radio: 'revised'
      }
    },
    methods: {
      closeDetails() {
        this.$emit('closeDetails', false);
      },
      returnNull(value){
        if(value){
          return value
        }else if(value === undefined || value === null) {
          return '-'
        }else {
          return '-'
        }
      },
      closeComments() {
        this.$emit('closeComments', false);
      },
      cancelReject() {
        this.commentDialog = false;
      },
      rejectItem() {
        this.$emit('rejectItem', this.comment_value, this.status_radio);
      },
      checkComment(comment){
        const lowComment = comment.toLowerCase()
        if(lowComment == 'approved' || lowComment == 'rejected' || lowComment == 'revised' || lowComment == 'submitted' || lowComment == "cancelled"){
          return this.$i18n.t((comment).toLowerCase())
        }else{
          return comment
        }
      },
    },
    
  };
</script>
<style scoped>
  .v-divider {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .blueimp-gallery {
    background: rgba(0, 0, 0, 0.7) !important;
  }

  .blueimp-gallery-display {
    display: block;
    opacity: 1;
  }
</style>